export default __webpack_public_path__ + "static/media/discord.3165d4b5.webp";